export const getWindow = () => globalThis.window;
